/**
 * Nested-IA alias route — round 4 / #228.
 *
 * Mounts the connection detail page at `/connections/mcp/$connectionId`
 * so the Codex full-baseline IA inventory resolves. Same component as
 * the flat /connections/$connectionId and the api/$connectionId alias;
 * the unified detail page auto-detects MCP vs API by trying both
 * lookup hooks.
 */

import { createFileRoute } from '@tanstack/react-router';
import { ConnectionDetailPage } from './$connectionId';

export const Route = createFileRoute('/connections/mcp/$connectionId')({
  component: McpInstallDetailRoute,
});

function McpInstallDetailRoute() {
  const { connectionId } = Route.useParams();
  // #755 — typed alias knows this is the MCP side; skip the API lookup.
  return <ConnectionDetailPage connectionId={connectionId} expectedType="mcp" />;
}
